import { Tab, TabContext, TabList } from '@shared/components';

import { useProctorRequestListSearchParams } from '../../hooks';
import { type ProctorRequestStatus } from '../../types';

const TAB_ITEMS: { value: ProctorRequestStatus; label: string }[] = [
  {
    value: 'DRAFT',
    label: 'แบบร่าง',
  },
  {
    value: 'IN_REVIEW',
    label: 'อยู่ระหว่างอนุมัติ',
  },
  {
    value: 'REJECTED',
    label: 'ไม่อนุมัติ',
  },
];

export default function ProctorRequestListNavigationTabs() {
  const [{ status }, { changeStatus }] = useProctorRequestListSearchParams();

  const handleClick = (value: ProctorRequestStatus) => {
    changeStatus(value);
  };

  return (
    <TabContext value={status}>
      <TabList
        sx={(theme) => ({
          p: theme.spacing(4, 4, 0, 4),
        })}
      >
        {TAB_ITEMS.map((tab) => {
          return (
            <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
              onClick={() => handleClick(tab.value)}
              sx={{
                minWidth: 'unset',
              }}
            />
          );
        })}
      </TabList>
    </TabContext>
  );
}
